/**
 * DOG1 Mengen-Card-Picker (R2.1, V2)
 *
 * - Reactive Pro-Dose-Preis + Rabatt-Badge je nach Modus (Sparabo/Einmalkauf)
 * - Modus-Detection via URL-Param `selling_plan` (URL hat ihn → Sparabo)
 * - Card-Klick: Variant-Switch via Radio-Input + URL-Sync mit history.replaceState
 *
 * Stückzahl-Quelle: Variant-Title-Parsing (`/^(\d+)x\b/i`), Fallback data-unit-count.
 * Appstle-unabhängig: lauscht auf URL-Changes (popstate + gepatchtes pushState/
 * replaceState), nicht auf Appstle-DOM-Mutationen. Der `selling_plan`-Param
 * wird hier NICHT angefasst — er gehört Appstle.
 */
(function () {
  'use strict';

  var GRID = document.querySelector('.dog1-pdp-menge__grid');
  if (!GRID) return;

  var ABO_DISCOUNT = window.DOG1_SUBSCRIPTION_DISCOUNT || 0.15;
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: CURRENCY,
    }).format(cents / 100);
  }

  /** Stückzahl autoritativ aus dem Variant-Title parsen, sonst data-unit-count. */
  function getUnitCount(card) {
    var title = card.dataset.variantTitle || '';
    var match = title.match(/^(\d+)x\b/i);
    if (match) return parseInt(match[1], 10);
    var fallback = parseInt(card.dataset.unitCount, 10);
    return fallback > 0 ? fallback : 0;
  }

  var CARDS = Array.prototype.slice.call(GRID.querySelectorAll('.dog1-pdp-menge__card'));

  /**
   * Referenz für die Ersparnis-Berechnung: Pro-Dose-Preis der kleinsten
   * Variante im Einmalkauf-Modus (= 1×-Einzelpreis, Marketing-Sicht).
   */
  var BASE_PRICE_PER_UNIT = (function () {
    var minUnits = Infinity;
    var ref = 0;
    CARDS.forEach(function (card) {
      var units = getUnitCount(card);
      var basePrice = parseInt(card.dataset.basePrice, 10);
      if (units > 0 && basePrice > 0 && units < minUnits) {
        minUnits = units;
        ref = basePrice / units;
      }
    });
    return ref;
  })();

  function detectModus() {
    return new URLSearchParams(window.location.search).has('selling_plan') ? 'abo' : 'einmal';
  }

  function updateCards(modus) {
    CARDS.forEach(function (card) {
      var basePrice = parseInt(card.dataset.basePrice, 10);
      var unitCount = getUnitCount(card);
      if (!basePrice || !unitCount) return;

      var effectivePrice = modus === 'abo' ? basePrice * (1 - ABO_DISCOUNT) : basePrice;
      var pricePerUnit = effectivePrice / unitCount;

      var priceSlot = card.querySelector('[data-price-per-unit-slot]');
      if (priceSlot) priceSlot.textContent = formatMoney(pricePerUnit);

      var badge = card.querySelector('[data-badge-slot]');
      if (badge) {
        var savingsPct = BASE_PRICE_PER_UNIT
          ? Math.round(((BASE_PRICE_PER_UNIT - pricePerUnit) / BASE_PRICE_PER_UNIT) * 100)
          : 0;
        if (savingsPct > 0) {
          badge.textContent = '-' + savingsPct + '%';
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
    });
  }

  // Card-Klick → Variant-ID im Form ist via Radio (name="id") schon gesetzt.
  // Zusätzlich `variant`-Param in die URL syncen + Appstle benachrichtigen.
  GRID.addEventListener('change', function (e) {
    var radio = e.target.closest('.dog1-pdp-menge__radio');
    if (!radio) return;
    var card = radio.closest('.dog1-pdp-menge__card');
    if (!card || !card.dataset.variantId) return;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', card.dataset.variantId);
    // selling_plan NICHT anfassen — gehört Appstle.
    history.replaceState({}, '', url);

    // Appstle rendert sein Widget bei popstate neu.
    window.dispatchEvent(new PopStateEvent('popstate'));

    var form = card.closest('form');
    if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // history.pushState/replaceState patchen, um auch Appstle-getriebene
  // URL-Changes zu fangen (popstate feuert dabei nicht von selbst).
  if (!window.__dog1HistoryPatched) {
    window.__dog1HistoryPatched = true;
    var origPush = history.pushState;
    history.pushState = function () {
      var ret = origPush.apply(this, arguments);
      window.dispatchEvent(new Event('dog1:urlchange'));
      return ret;
    };
    var origReplace = history.replaceState;
    history.replaceState = function () {
      var ret = origReplace.apply(this, arguments);
      window.dispatchEvent(new Event('dog1:urlchange'));
      return ret;
    };
  }

  window.addEventListener('dog1:urlchange', function () {
    updateCards(detectModus());
  });
  window.addEventListener('popstate', function () {
    updateCards(detectModus());
  });

  // Initial-Render
  updateCards(detectModus());
})();
